export default __webpack_public_path__ + "static/media/audience.57c2f80b.svg";